import * as React from 'react';
import { SVGProps } from 'react';

const SvgDoctor = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      d="M25.6 19.7 20 25.3l-5.6-5.6m12 7.3h-3.9"
    />
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      d="M29 31v-4.7c0-4.4-3.6-8-8-8h-2c-4.4 0-8 3.6-8 8v4.8m14.1-21v3.1c0 2.8-2.3 5.1-5.1 5.1s-5.1-2.3-5.1-5.1v-3.1"
    />
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      d="M14.9 13.2V8.9c0-2.2 1.8-4 4-4h2.2c2.2 0 4 1.8 4 4v4.2"
    />
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      d="M14.9 9.9c1.6-.4 3.3-.7 5.1-.7s3.5.2 5.1.7"
    />
    <path fill={props.fill} d="M29.8 31v4H14.2l-4-3.9 19.6-.1z" />
  </svg>
);

export default SvgDoctor;
